// footer
import Footer from "../../../../../layouts/template/charge/footer/footer";
// splitter
import {splitNumber} from "../../../../../features/splitNumber/splitNumber";
import {useParams} from "react-router-dom";
// layouts
import Header from "../../../../../layouts/template/charge/header/header";
// hook
import {useEffect, useState} from "react";

const HelpSuccess = () => {
    const {reference} = useParams();
    const {tracking} = useParams();
    const {amount} = useParams<any>();
    const [price, setPrice] = useState<any>()
    const [status, setStatus] = useState<boolean>(true);
    useEffect(() => {
        setStatus(true);
        setPrice(parseFloat(amount ? amount : ''))
    }, [amount]);
    return (
        <>
            <article className={'payment container-fluid h-100 overflow-x-hidden'}>
                <div className="row justify-content-center align-items-center h-100">
                    <div className="col-12">
                        <div id={'text-field'}>
                            <Header/>
                            <section className={'profile container'}>
                                <div className={'profile-items d-flex justify-content-center text-center'}>
                                    <div className={'profile-img position-relative'}
                                         style={{backgroundImage: `url(${require('../../../../../assets/media/images/payment/help.jpg')})`}}></div>
                                </div>
                                <p className={'h5 card-text fw-bold text-white mt-1 mb-1'}>
                                    قرارگاه سید الشهدا (ع)
                                </p>
                            </section>
                            <section className={'bg-white text-center py-3 my-2 mt-3'}>
                                <p className={'card-text font-medium dark-green mb-1'}>
                                    بدون نیاز به نصب اپلیکیشن
                                </p>
                                <h4 className={'dark-green fw-bold mt-1'}>
                               <span className={'price-amount ms-1'}>
                                   {splitNumber(price / 10)}
                               </span>
                                    تومان
                                </h4>
                                <h5 className={'text-ir-success fw-bold mb-0'}>
                                    با موفقیت پرداخت شد
                                </h5>
                            </section>
                            <section id={'endPoint'} className={'container'}>
                                <p className={'h6 dark-green card-text fw-bold mb-2'}>
                                    مبلغ برداشت شده از کارت بانکی
                                </p>
                                <p className={'price mt-2 dark-green card-text'}>
                                   <span className={'price-amount ms-1'}>
                                        {splitNumber(price / 10)}
                                   </span>
                                    تومان
                                </p>
                            </section>
                            <section className={'action container my-1 mb-0'}>
                                <ul className={'list-group px-4'}>
                                    <li className={'list-group-item px-0 pb-0'}>
                                        <div className={'d-flex justify-content-between align-items-center'}>
                                            <strong className={'h6 fw-bold dark-green align-middle'}>شماره مرجع</strong>
                                            <span className={'h6 dark-green align-middle'}>
                                              {reference}
                                           </span>
                                        </div>
                                    </li>
                                    <li className={'list-group-item pt-0 px-0'}>
                                        <div className={'d-flex justify-content-between align-items-center'}>
                                            <strong className={'h6 fw-bold dark-green align-middle'}>شماره
                                                پیگیری
                                            </strong>
                                            <span className={'h6 dark-green align-middle'}>
                                                 {tracking}
                                           </span>
                                        </div>
                                    </li>
                                </ul>
                            </section>
                        </div>
                        {/* footer */}
                        <Footer status={status}/>
                    </div>
                </div>
            </article>
        </>
    )
}

export default HelpSuccess;